import { render, staticRenderFns } from "./GroupAccountSelect.vue?vue&type=template&id=654c6354&"
import script from "./GroupAccountSelect.vue?vue&type=script&lang=js&"
export * from "./GroupAccountSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports